import {
  GET_PRICE,
  GET_PRICE_SUCCESSFUL,
  GET_PRICE_FAILED,
  VERIFY_WALLET,
  VERIFY_WALLET_SUCCESSFUL,
  VERIFY_WALLET_FAILED
} from "./actionTypes"

export const getPrice = (data, callback) => {
  return {
    type: GET_PRICE,
    payload: { data, callback },
  }
}

export const getPriceSuccessful = data => {
  return {
    type: GET_PRICE_SUCCESSFUL,
    payload: data,
  }
}

export const getPriceFailed = data => {
  return {
    type: GET_PRICE_FAILED,
    payload: data,
  }
}

export const verifyWallet = (data, callback) => {
  return {
    type: VERIFY_WALLET,
    payload: { data, callback },
  }
}

export const verifyWalletSuccessful = data => {
  return {
    type: VERIFY_WALLET_SUCCESSFUL,
    payload: data,
  }
}

export const verifyWalletFailed = data => {
  return {
    type: VERIFY_WALLET_FAILED,
    payload: data,
  }
}